import axios from 'axios';

const API_BASE_URL = 'http://192.168.100.184:8000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Blog Posts
export const getBlogPosts = () => api.get('/blog-posts/');
export const getBlogPost = (slug) => api.get(`/blog-posts/${slug}/`);
export const addComment = (slug, commentData) => api.post(`/blog-posts/${slug}/add_comment/`, commentData);
export const likePost = (slug) => api.post(`/blog-posts/${slug}/like/`);
export const dislikePost = (slug) => api.post(`/blog-posts/${slug}/dislike/`);

// Newsletter
export const subscribeToNewsletter = (email) => api.post('/newsletter-subscriptions/', { email });

// Job Listings
export const getJobListings = () => api.get('/job-listings/');
export const getJobListing = (id) => api.get(`/job-listings/${id}/`);

// Job Applications
export const submitJobApplication = (formData) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return api.post('/job-applications/', formData, config);
};

export default api; 